import { useState, useCallback } from 'react';

const useLoader = (initialState = false) => {
  const [isLoading, setIsLoading] = useState(initialState);
  const [loadingMessage, setLoadingMessage] = useState("Loading...");
  const [loadingType, setLoadingType] = useState("loading");

  // Show loader with optional message
  const showLoader = useCallback((message = "Loading...", type = "loading") => {
    setLoadingMessage(message);
    setLoadingType(type);
    setIsLoading(true);
  }, []);

  // Hide loader
  const hideLoader = useCallback(() => {
    setIsLoading(false);
  }, []);

  // Show success message briefly then hide
  const showSuccess = useCallback((message = "Success!", duration = 2000) => {
    setLoadingMessage(message);
    setLoadingType("success");
    setIsLoading(true);
    
    setTimeout(() => {
      setIsLoading(false);
    }, duration);
  }, []);

  // Show error message briefly then hide
  const showError = useCallback((message = "Error occurred!", duration = 3000) => {
    setLoadingMessage(message);
    setLoadingType("error");
    setIsLoading(true);
    
    setTimeout(() => {
      setIsLoading(false);
    }, duration);
  }, []);

  // Wrapper function for async operations
  const withLoader = useCallback(async (asyncFunction, loadingMsg = "Loading...") => {
    try {
      showLoader(loadingMsg);
      const result = await asyncFunction();
      hideLoader();
      return result;
    } catch (error) {
      showError(error.message || "An error occurred");
      throw error;
    }
  }, [showLoader, hideLoader, showError]);

  return {
    isLoading,
    loadingMessage,
    loadingType,
    showLoader,
    hideLoader,
    showSuccess,
    showError,
    withLoader
  };
};

export default useLoader;
